import { render, staticRenderFns } from "./WorkTasks.vue?vue&type=template&id=5c1875a6&"
import script from "./WorkTasks.vue?vue&type=script&lang=ts&"
export * from "./WorkTasks.vue?vue&type=script&lang=ts&"
import style0 from "./WorkTasks.vue?vue&type=style&index=0&id=5c1875a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports